/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { useQuery } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import {
    shape, string, func, bool, arrayOf, object,
} from 'prop-types';
import { connect } from 'react-redux';
import GraphqlPortalLoader from '../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import findContent from '../../gql/queries/findContent';
import { getBrand } from '../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import CGCModal from './Partials/CGCModal';
import { getCGCCardData, getDataDictionary } from '../../../state/ducks/App/App-Selectors';
import GraphlqlCelebrationsCustomsCard from './Partials/CustomLabels/GraphlqlCelebrationsCustomsCard';

const CelebrationsGreetingCard = ({
    brand,
    closeModal,
    openModal,
    existingCgcData,
    orderItemsId,
    isCelebrationsCustomsCard,
    personalizationCustomsType,
    productSku,
    updateCGCCustomsData,
    customCardData,
    dataDictionary,
}) => {
    let response = null;
    if (!openModal || !orderItemsId) {
        response = null;
    }
    const query = `{\\"brand\\": \\"${brand?.domain}\\"}`;
    const BRAND_DATA_QUERY = findContent({
        brand: 'gci',
        contentType: 'brands',
        reference: 'occasions_rank.occasions.reference',
        query,
    });
    const { data, error, loading } = useQuery(BRAND_DATA_QUERY);
    if (loading) {
        response = <GraphqlPortalLoader />;
    }
    if (error || !data) {
        mbpLogger.logError({
            query: BRAND_DATA_QUERY,
            component: 'GraphqlBrandDataContainer.js',
            message: `Failed to fetch content data for: content type brands,query ${query} on brand gci`,
            error,
        });
        response = null;
    }
    // get occasion array of brand
    // Checks if data already exists and pass the data to editCard.
    // If no existing data then value will be null to avoid running the code
    if (data?.findContent?.content?.entries?.[0]) {
        const brandData = data.findContent.content.entries[0];
        let editCard = {};
        if (existingCgcData?.length) {
            editCard = existingCgcData?.find((cgcData) => cgcData?.orderItemId === orderItemsId);
        }

        if (isCelebrationsCustomsCard) {
            response = (
                <GraphlqlCelebrationsCustomsCard
                    brandUid={brandData.uid}
                    orderItemsId={orderItemsId}
                    personalizationCustomsType={personalizationCustomsType}
                    closeModal={closeModal}
                    openModal={openModal}
                    updateCGCCustomsData={updateCGCCustomsData}
                    customCardData={customCardData}
                    dataDictionary={dataDictionary}
                />
            );
        } else {
            response = (
                brandData
            && (
                <CGCModal
                    editCard={editCard}
                    brand={brand}
                    brandData={brandData}
                    orderItemsId={orderItemsId}
                    brandUid={brandData.uid}
                    openModal={openModal}
                    closeModal={closeModal}
                    occasionData={brandData.occasions_rank}
                    isCelebrationsCustomsCard={isCelebrationsCustomsCard}
                    personalizationCustomsType={personalizationCustomsType}
                    productSku={productSku}
                    updateCGCCustomsData={updateCGCCustomsData}
                />
            )
            );
        }
    }
    return response;
};
CelebrationsGreetingCard.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    closeModal: func.isRequired,
    productSku: string.isRequired,
    openModal: bool.isRequired,
    orderItemsId: string.isRequired,
    existingCgcData: arrayOf(
        shape({
            orderItemsId: string,
        }),
    ).isRequired,
    isCelebrationsCustomsCard: bool.isRequired,
    personalizationCustomsType: string.isRequired,
    updateCGCCustomsData: func.isRequired,
    dataDictionary: object,
};
CelebrationsGreetingCard.defaultProps = {
    dataDictionary: {},
};
const mapStateToProps = (state) => ({
    brand: getBrand(state),
    existingCgcData: getCGCCardData(state),
    dataDictionary: getDataDictionary(state),
});
export default connect(mapStateToProps)(CelebrationsGreetingCard);
